const esc = (v) => String(v || "").replace(/\\/g, "\\\\").replace(/([,;])/g, "\\$1").replace(/\r?\n/g, " ");

const nameParts = (name) => {
  const p = String(name || "").trim().split(/\s+/);
  return p.length > 1 ? `${esc(p[p.length - 1])};${esc(p.slice(0, -1).join(" "))};;;` : `${esc(p[0])};;;;`;
};

export const badgeVcard = (d) => [
  "BEGIN:VCARD", "VERSION:3.0",
  `N:${nameParts(d.name)}`,
  `FN:${esc(d.name)}`,
  d.phone && `TEL;TYPE=CELL:${esc(d.phone)}`,
  d.email && `EMAIL:${esc(d.email)}`,
  d.facility && `ORG:${esc(d.facility)}`,
  d.ticket_no && `NOTE:GAMLS EventHub ticket ${d.ticket_no}`,
  d.ticket_no && `X-GAMLS-TICKET:${d.ticket_no}`,
  "END:VCARD",
].filter(Boolean).join("\r\n");
